import selectedAccount from '../stores/selectedAccount.store';

export const setSelectedAccountDefaultMode = () => {
	selectedAccount.update((store) => ({
		...store,
		loading: false,
		loaded: false,
		account: undefined,
		mode: undefined
	}));
};

export const setSelectedAccountEditMode = (account: any) => {
	selectedAccount.update((store) => ({
		...store,
		loading: false,
		loaded: false,
		account: account,
		mode: 'edit'
	}));
};

export const setSelectedAccountshowMode = (account: any) => {
	selectedAccount.update((store) => ({
		...store,
		loading: false,
		loaded: false,
		account: account,
		mode: 'show'
	}));
};
